module.exports = __webpack_public_path__ + "img/tradeIn-social-ipad.f6429677.png";